

import React from "react";
import PresentationComponent from "@/components/Presentation/PresentationComponent";
import AvantagesComponent from "@/components/Avantages/AvantagesComponent";
import ServicesComponent from "@/components/Services/ServiceComponent";
import ImpactComponent from "@/components/Impact/ImpactComponent";
import EtapesComponent from "@/components/Etapes/EtapesComponent";
import PartenariatsComponent from "@/components/Partenariats/PartenariatsComponent";
import CheptelComponent from "@/components/Cheptel/CheptelComponent";
import ListeTemoignages from "@/components/ListeTemoignage/ListeTemoignages";
import ActualitesComponent from "@/components/Actualites/ActualitesComponent";
import ContactComponent from "@/components/Formulairecontact/ContactComponent";
import styles from "./Accueil.module.css";
import { GENERAL_DATA } from "@/constants/data";

const Accueil = () => {
  return (
    <div className={styles.mainContent}>
      <PresentationComponent
        hero={GENERAL_DATA.presentation.hero}
        features={GENERAL_DATA.force.features}
      />

      <AvantagesComponent
        title={GENERAL_DATA.avantages.title}
        subtitle={GENERAL_DATA.avantages.subtitle}
        features={GENERAL_DATA.avantages.features}
        imageSrc={GENERAL_DATA.avantages.imageSrc}
      />

      <ServicesComponent
        sectionHeader={GENERAL_DATA.services.sectionHeader}
        sectionMainTitle={GENERAL_DATA.services.sectionMainTitle}
        sectionDescription={GENERAL_DATA.services.sectionDescription}
        services={GENERAL_DATA.services.services}
      />

      <ImpactComponent
        title={GENERAL_DATA.impact.title}
        subtitle={GENERAL_DATA.impact.subtitle}
        sections={GENERAL_DATA.impact.sections}
        images={GENERAL_DATA.impact.images}
      />

      <EtapesComponent
        title={GENERAL_DATA.etapes.title}
        subtitle={GENERAL_DATA.etapes.subtitle}
        steps={GENERAL_DATA.etapes.steps}
      />

      <CheptelComponent />

      <ListeTemoignages />

      <PartenariatsComponent
        title={GENERAL_DATA.partenariats.title}
        subtitle={GENERAL_DATA.partenariats.subtitle}
        description={GENERAL_DATA.partenariats.description}
        partners={GENERAL_DATA.partenariats.partners}
      />

      <ActualitesComponent
        title={GENERAL_DATA.actualites.title}
        subtitle={GENERAL_DATA.actualites.subtitle}
        description={GENERAL_DATA.actualites.description}
        news={GENERAL_DATA.actualites.news}
      />

      {/* <ForceComponent features={GENERAL_DATA.force.features} /> */}

      <ContactComponent />
    </div>
  );
};

export default Accueil;
